import { BitrixVue } from "ui.vue";

BitrixVue.component("AdditionalButtonHide", {
	props: ["state", "title"],
	template: `
		<div class="additional-destroy" @click="$emit('setInnerVisibility')">Убрать {{this.title}}</div>
`,
});

